import { useContext } from 'react';
import { ModalHistoryContext } from '../History/History.js';

const useModalHistory = ()=>{
    return useContext(ModalHistoryContext);
};

export { useModalHistory };
//# sourceMappingURL=useModalHistory.js.map
